<template>
  <div class="SelectInput">
    <div
      v-if="inputHas.label"
      class="SelectInput-label p p-bold"
      :class="{
        required: required,
        'app-color-black': labelColor === SELECTINPUT_COLOR.black,
        'app-color-1': labelColor === SELECTINPUT_COLOR.purple_dark,
      }"
    >
      {{ label }}
    </div>

    <v-select
      v-model="selected"
      :label="label"
      :hint="hint"
      :readonly="readonly"
      persistent-hint
      :prefix="prefix"
      :rules="rules"
      :hide-details="hideDetails"
      single-line
      :placeholder="inputHas.placeholder ? placeholder : inputHas.label ? label : '...'"
      :class="{ 'no-field__details-block': hint === '' }"
      color="#004f9f"
      :items="options"
      :item-text="itemText"
      :item-value="itemValue"
      :prepend-inner-icon="inputHas.icon ? icon : null"
      return-object
      outlined
      attach
      :menu-props="menuProps"
      @change="handleUpdate"
    >
      <template v-slot:selection="data">
        <div
          :class="{ 'font-weight-semibold': prefix }"
          class="v-select__selection v-select__selection--comma"
        >
          {{ data.item.label }}
        </div>
      </template>
      <template v-slot:append>
        <v-icon color="#009ee0">expand_more</v-icon>
      </template>
    </v-select>
  </div>
</template>

<script type="text/javascript">
  import mixinUi from '@/mixins/utils/ui.js'

  import { SELECTINPUT_COLOR } from './SelectInput.const'

  export default {
    mixins: [mixinUi,],
    props: {
      label: {
        type: String,
        default: '',
      },
      hint: {
        type: String,
        default: '',
      },
      prefix: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      /* @todo: replace default by value to fit with design pattern */
      default: {
        validator: (v) => true,
        default: null,
      },
      icon: {
        type: String,
        default: '',
      },
      itemText: {
        type: String,
        default: '',
      },
      itemValue: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        default: (d) => [],
      },
      labelColor: {
        type: String,
        default: SELECTINPUT_COLOR.purple_dark,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      rules: {
        type: Array,
        default: () => [],
      },
      required: {
        type: Boolean,
        default: false,
      },
      hideDetails: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        SELECTINPUT_COLOR,
        selected: null,
        menuProps: {
          offsetY: true,
          contentClass: 'SelectInput_menu',
          fixed: false,
        },
      }
    },
    computed: {
      inputHas() {
        const out = {
          label: this.label !== '',
          placeholder: this.placeholder !== '',
          icon: this.icon !== '',
          default: this.default !== null && this.default !== '',
        }

        return out
      },
    },
    watch: {
      default: function(val) {
        this.setFromValue(val)
      },
    },
    created() {
      if (this.inputHas.default) {
        this.setFromValue(this.default)
      }
    },
    methods: {
      setFromValue(value) {
        for (const i in this.options) {
          if (this.options[i][this.itemValue] === value) {
            const obj = {}
            obj[this.itemValue] = value
            obj[this.itemText] = this.options[i][this.itemText]
            this.selected = obj
          }
        }
      },

      handleUpdate(obj) {
        this.$emit('input', obj[this.itemValue])
      },
    },
  }
</script>

<style scoped lang="scss">
/* stylelint-disable max-nesting-depth */
.SelectInput {
  .no-field__details-block {
    .v-text-field__details {
      // display: none;
    }
  }

  .SelectInput-label {
    margin-left: 8px;
    margin-bottom: 4px;
    &.required::after {
      content: '*';
    }
  }

  .v-input.v-select {
    .v-input__control {
      .v-text-field__details {
        .v-messages__message {
          // color: $color-727efd;
          font-size: 13px;
          letter-spacing: 0;
          line-height: 20px;
        }
      }
      .v-input__slot {
        margin-bottom: 0;
        min-height: 52px;
        .v-input__prepend-inner {
          margin-top: 0;
          height: 48px;
          position: relative;
          left: -11px;
          width: 48px;
          margin-right: -11px;
          border: 1.4px solid $color-d9dfff;
          border-radius: 8px 0 0 8px;
          background-color: $color-f3f9ff;
          text-align: center;
          padding-right: 0;
          padding-top: 12px;

          .v-input__icon {
            i {
              font-size: 20px;
              color: $color-004f9f;
            }
          }
        }

        fieldset {
          max-height: 53px;
          border: 1.4px solid $color-d9dfff;
          border-radius: 8px;
          -webkit-border-radius: 8px;
        }

        .v-select__slot {
          max-height: 48px;
          padding-left: 8px;

          label {
            position: initial !important;
          }

          .v-text-field__prefix {
            color: $color-004f9f;
            font-size: 16px;
            letter-spacing: 0.24px;
            line-height: 24px;
          }
          .v-select__selections {
            .v-select__selection {
              color: $color-004f9f;
              font-size: 16px;
              letter-spacing: 0.24px;
              line-height: 24px;
            }
          }
          .v-input__append-inner {
            margin-top: 13px;
          }
        }
      }
    }
  }
  .v-input__append-inner {
    margin-top: 12px !important;
  }
}
/* Slider Input Menu */
.SelectInput_menu.v-menu__content {
  &.menuable__content__active {
    border: 1px solid $color-d9dfff;

    .v-list-item {
      &:hover {
        background-color: inherit;
        color: $color-d9dfff !important;
        font-weight: 600;

        &:before {
          opacity: 0.12 !important;
        }
      }
      &--active {
        color: $color-d9dfff !important;
        font-weight: 600;

        &:before {
          opacity: 0.12 !important;
        }
      }
    }
  }
}
</style>
